import {Input as AntdInput} from "../../../../__snowpack__/pkg/antd.js";
import React from "../../../../__snowpack__/pkg/react.js";
export default React.forwardRef(function Input(props, ref) {
  const {trim, value, onChange, onBlur, ...restProps} = props;
  return /* @__PURE__ */ React.createElement(AntdInput, {
    ref,
    value,
    ...restProps,
    onBlur: (e) => {
      if (trim && e.target.value && e.target.value !== e.target.value.trim()) {
        e.target.value = e.target.value.trim();
        onChange?.(e);
      }
      onBlur?.(e);
    },
    onChange
  });
});
